import { DataBean } from "../DataBean";

export class PersonalReferences extends DataBean {


    public async getPersonalReferencesCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getPersonalReferencesCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
 public async getPersonalReferencesAccountReport(page:any,Rows:any,props:any): Promise<any> {
        return this.getCustomService("TalentERP", "com.advantage.shared.Report_getPersonalReferencesAccountReport_Number_Number_java.util.Map", [page,Rows,props]);
    }
}